'use client';
import { $generateHtmlFromNodes } from '@lexical/html';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary';
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin';
import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { $getRoot } from 'lexical';
import { cn } from '~/style';
import { sanitizeHtml } from '~/utils';

export const TextEditor = ({
  value,
  onChange,
  className,
}: {
  value: any | null;
  onChange: (options: {
    json: any | null;
    html: string | null;
    text: string | null;
  }) => void;
  className?: string;
}) => {
  return (
    <div className="relative">
      <LexicalComposer
        initialConfig={{
          namespace: 'PostTextEditor',
          onError: () => {},
          editorState: (editor) => {
            if (!value) return null;

            editor.update(() => {
              const editorState = editor.parseEditorState(value);

              editor.setEditorState(editorState);
            });
          },
        }}
      >
        <RichTextPlugin
          contentEditable={
            <ContentEditable
              id="content-text"
              className={cn('min-h-60 outline-none md:text-lg', className)}
              style={{ padding: 0, margin: 0 }}
            />
          }
          ErrorBoundary={LexicalErrorBoundary}
          placeholder={
            <div className="absolute left-0 top-0 pl-1 pt-0.5 text-muted-foreground/50">
              Write something...
            </div>
          }
        />

        <HistoryPlugin />

        <OnChangePlugin
          onChange={(editorState, editor) => {
            editorState.read(() => {
              const html = $generateHtmlFromNodes(editor, null);
              const sanitizedHtml = sanitizeHtml(html);
              const text =
                $getRoot().getTextContent().replace(/\n+/g, ' ').trim() || null;

              onChange({
                json: editorState.toJSON(),
                html: sanitizedHtml,
                text,
              });
            });
          }}
        />
      </LexicalComposer>
    </div>
  );
};
